let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("j2tB4")).then(() => parcelRequire('1GckT'));